export default __webpack_public_path__ + "static/media/dermatology.4ebc6cf3.png";